import React, {
  useEffect,
  useState,
} from "react";

import axios from "../../../utills/api";

import {
  Card,
  CardBody,
  Badge,
  Spinner,
} from "reactstrap";

const GuestActivity = ({
  booking,
}) => {

  const [foodOrders, setFoodOrders] =
    useState([]);

  const [
    housekeepingRequests,
    setHousekeepingRequests,
  ] = useState([]);

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {

    try {

      const [foodRes, hkRes] =
        await Promise.all([
          axios.get(
            `/food/order/guest?roomNumber=${booking.assignedRoom?.roomNumber}&tenantId=${booking.tenantId}`
          ),

          axios.get(
            `/housekeeping/guest-request`
          ),
        ]);

      setFoodOrders(
        foodRes.data || []
      );

      setHousekeepingRequests(
        hkRes.data || []
      );

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);

    }
  };

  const getStatusColor = (
    status
  ) => {

    switch (
    status?.toUpperCase()
    ) {

      case "RECEIVED":
        return "warning";

      case "PREPARING":
        return "info";

      case "READY":
        return "primary";

      case "DELIVERED":
        return "success";

      case "COMPLETED":
        return "success";

      case "IN_PROGRESS":
        return "info";

      case "ASSIGNED":
        return "primary";

      default:
        return "secondary";
    }
  };

  if (loading) {
    return (
      <div className="text-center py-4">
        <Spinner />
      </div>
    );
  }

  return (
    <div>

      {/* FOOD ORDERS */}

      <h5 className="mb-3">
        My Food Orders
      </h5>

      {foodOrders.length === 0 ? (
        <Card className="mb-4">
          <CardBody>
            No food orders found
          </CardBody>
        </Card>
      ) : (
        foodOrders.map(
          (order) => (
            <Card
              key={order._id}
              className="mb-3 shadow-sm"
            >
              <CardBody>

                <div className="d-flex justify-content-between align-items-center">

                  <div>

                    <div className="fw-bold">
                      {order.orderId}
                    </div>

                    <small>
                      ₹
                      {
                        order.finalAmount
                      }
                    </small>

                  </div>

                  <Badge
                    color={getStatusColor(
                      order.chefStatus || order.status
                    )}
                    className="px-3 py-2 d-flex align-items-center justify-content-center"
                    style={{
                      fontSize: "0.8rem",
                      borderRadius: "20px",
                      whiteSpace: "nowrap",
                      height: "auto",
                      minHeight: "unset"
                    }}
                  >
                    {order.chefStatus || order.status}
                  </Badge>

                </div>

              </CardBody>
            </Card>
          )
        )
      )}

      {/* HOUSEKEEPING */}

      <h5 className="mb-3 mt-4">
        Housekeeping Requests
      </h5>

      {housekeepingRequests.length ===
        0 ? (
        <Card>
          <CardBody>
            No requests found
          </CardBody>
        </Card>
      ) : (
        housekeepingRequests.map(
          (item) => (
            <Card
              key={item._id}
              className="mb-3 shadow-sm"
            >
              <CardBody>

                <div className="d-flex justify-content-between align-items-center">
                  <div>

                    <div className="fw-bold">
                      {
                        item.requestType
                      }
                    </div>

                    <small>
                      Room{" "}
                      {
                        item.roomNumber
                      }
                    </small>

                  </div>

                  <Badge
                    color={getStatusColor(item.status)}
                    className="px-3 py-2 d-flex align-items-center justify-content-center"
                    style={{
                      fontSize: "0.8rem",
                      borderRadius: "20px",
                      whiteSpace: "nowrap",
                      height: "auto",
                      minHeight: "unset"
                    }}
                  >
                    {item.status}
                  </Badge>

                </div>

              </CardBody>
            </Card>
          )
        )
      )}

    </div>
  );
};

export default GuestActivity;